export default __webpack_public_path__ + "static/media/asa.8af55dc5.png";